/**
 * Returns the string representaion of the plan to be displayed in the UI
 *
 * @param {string} selectedService - Service selected by the user.
 * This must match one of the plan nodes.
 * @param {Object} plan - The plan to create the UI string for
 * @returns {{sizeInfo: string, nodeInfo:string}} - sizeInfo: string representation of the plan; nodeInfo: information on the node breakdown
 */
export default function createPlanDisplay(selectedService, plan) {
  const currentService = selectedService.toLowerCase();
  const { nodes } = plan;
  const isRedis = currentService === 'redis';
  const isMongo = currentService === 'mongodb';

  const planNode = isMongo ? nodes[currentService] || nodes.mongod : nodes[currentService];

  let memory = null;
  let storage = null;

  switch (currentService) {
    case 'redis':
      memory = planNode.memoryMb / 1024;
      break;

    case 'mongodb':
      memory = planNode.memoryMb / 1024;
      storage = planNode.diskSizeGb;
      break;

    default:
      memory = (planNode.memoryMb / 1024) * planNode.quantity;
      storage = planNode.diskSizeGb * planNode.quantity;
      break;
  }

  const nodeWord = planNode.quantity > 1 ? 'nodes' : 'node';

  const sizeInfo = isRedis ? `${memory}GB Memory` : `${storage}GB Storage / ${memory}GB Memory`;
  const nodeInfo = isRedis
    ? `${planNode.quantity} ${nodeWord} × ${memory}GB each`
    : `${planNode.quantity} ${nodeWord} × ${planNode.diskSizeGb}GB each`;

  return { sizeInfo, nodeInfo };
}
